
<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/system/system.vue